module.exports = __webpack_public_path__ + "static/media/mobileicon.936a13a6.svg";